<div [style.background]="supportModel().backgroundColor">
  <div id="gast-support" class="container" [style.color]="supportModel().textColor">
    <div class="row justify-content-center">
      <h4 class="portal-text">{{ supportModel().title1 }}</h4>
    </div>
    <div class="row justify-content-center">
      <h4 class="portal-text">{{ supportModel().title2 }}</h4>
    </div>
    <div class="row justify-content-center" style="margin-top: 52px; margin-bottom: 32px">
      <div class="col col-md-3 col-md-auto">
        <i class="fas fa-phone"></i>
        <span class="contact-text" style="margin-left: 4px">{{ supportModel().phone }}</span>
      </div>
      <div class="col col-md-3">
        <i class="fas fa-envelope"></i>
        <span class="contact-text" style="margin-left: 4px">{{ supportModel().email }}</span>
      </div>
    </div>
    <div class="row" style="padding-top: 15px" [class.text-right]="supportModel().textAlignment === 'right'">
      <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="inputSupportSurname">{{ supportModel().lastnameText }}</label>
              <input
                #firstname
                type="text"
                class="form-control"
                id="inputSupportSurname"
                [placeholder]="supportModel().lastnamePlaceholderText"
                [class.text-right]="supportModel().textAlignment === 'right'" />
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="inputSupportFirstname">{{ supportModel().firstnameText }}</label>
              <input
                #lastname
                type="text"
                class="form-control"
                id="inputSupportFirstname"
                [placeholder]="supportModel().firstnamePlaceholderText"
                [class.text-right]="supportModel().textAlignment === 'right'" />
            </div>
          </div>
        </div>
        <div class="row email-row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="inputSupportEmail">{{ supportModel().emailText }}</label>
              <input
                #email
                type="text"
                class="form-control"
                id="inputSupportEmail"
                [placeholder]="supportModel().emailPlaceholderText"
                [class.text-right]="supportModel().textAlignment === 'right'" />
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="selectSubjectOption" class="text">{{ supportModel().subjectText }}</label>
              <select
                #subject
                class="form-control"
                id="selectSubjectOption"
                [ngStyle]="{ 'text-align-last': supportModel().textAlignment === 'right' ? 'right' : 'left' }">
                @for (option of supportModel().subjectOptions; track option) {
                  <option value="{{ option }}">{{ option }}</option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group">
          <label for="textareaSupportMessage">{{ supportModel().messageText }}</label>
          <textarea
            #message
            class="form-control"
            id="textareaSupportMessage"
            style="resize: none; height: 110px"
            [placeholder]="supportModel().messagePlaceholder"
            [class.text-right]="supportModel().textAlignment === 'right'"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button
          class="btn btn-primary float-end"
          [style.background-color]="supportModel().sendButtonColor"
          (click)="onSendPressed(firstname.value, lastname.value, email.value, message.value, subject.value)">
          {{ supportModel().sendButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
